import {
    IPcEditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/editable-service-layer.interface';
import {
    EditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/editable-service-layer';
import {
    IPcEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/viewable-service-layer.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import MasterLayoutEditService from '@src/slide/application/service/master-layout-edit-service';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import PagingSelectionManager from '@src/slide/application/service/paging-selection/core';
import { IPagingSelectionManager } from '@src/slide/application/service/paging-selection/core/paging-selection-manager.interface';
import ParagraphManager from '@src/slide/application/service/paragraph-manager/core/paragraph-manager';
import TempElementManager from '@src/slide/application/service/temp-element-manager';
import ChartManager from '@src/slide/application/service/chart-manager';
import SelectedAnimManager from '@src/slide/application/service/selection/selected-anim-manager';
import RightSideBarManager from '@src/slide/application/service/right-side-bar-manager';
import { ISearchReplaceManager } from '@src/slide/application/service/search-replace-manager/search-replace-manager-v3.interface';
import { searchReplaceManagerDynamicConfig } from './service-dynamic-configs/search-replace-manager.config';
import GuidesManager from '@src/slide/application/service/guides-manager';
import { ITextRulerManager } from '@src/slide/application/service/text-ruler-manager/core/index.interface';
import { TextRulerManager } from '@src/slide/application/service/text-ruler-manager/core';
import GridLineManager from '@src/slide/application/service/grid-line-manager';
import AbsorbManager from '@src/slide/application/service/absorb-manager';
import { InsertTableRowColManager } from '@src/slide/application/service/insert-table-row-col-manager';
import { INumberTestManager } from '@src/slide/application/service/number-test-manager/number-test-manager.interface';
import { SlideDataServices, onSlideAppReady } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ISlideRatingService } from '@src/slide/application/service/slide-rating-and-improve/slide-rating-service.interface';
import { DynamicServiceLoader, IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IPcCopyPaste } from '@src/slide/application/service/copy-paste/core/pc/pc-copy-paste.interface';
import { pcCopyPasteManagerDynamicConfig } from '../../../base/service-layer/service-dynamic-configs/copy-paste.config';
import { initDynamicCopyPaste } from '../../../base/service-layer/common-init-procedures/copy-paste';
import ImportFilePipelineManager from '@src/slide/application/service/import-file-pipeline-manager/core';
import { importFileManagerDynamicConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/import-file-manager.config';
import { importFilePipelineManagerDynamicConfig } from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/import-file-pipeline-manager.config';
import { ImportFileInjectable } from '@src/slide/application/service/import-file-manager/inject/import-file-inject/toc/import-file-injectable';
import {
    IImportFileInjectable,
    IImportFileManager,
    IImportOnlineFileManager,
} from '@src/slide/application/service/import-file-manager/core/import-file-manager.interface';
import { IBulletsAndNumberingDialogManager } from '@src/slide/application/service/bullets-and-numbering-dialog-manager/core/interface';
import { importOnlineFileManagerConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/import-online-file-manager.config';
import { chartTrendlineManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/chart-trendline-manager.config';
import { bulletsAndNumberingDialogManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/bullets-and-numbering-dialog.config';
import { IChartTrendlineManager } from '@src/slide/application/service/chart-manager/chart-manager.interface';
import { IInsertTdocManager } from '@src/slide/application/service/insert-tdoc-manager/core/insert-tdoc-manager.interface';
import { insertTdocManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/insert-tdoc-manager.config';
import type { IColumnDialogManager } from '@src/slide/application/service/column-dialog-manager/core/interface';
import { columnDialogDynamicConfig } from './service-dynamic-configs/column-dialog.config';
import {
    IHistoryManager,
    IHistoryManagerInjectable,
} from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { HistoryManager } from '@src/slide/application/service/history-manager/core';
import { HistoryManagerInjectable } from '@src/slide/application/service/history-manager/inject/toc/history-manager-injectable';
import { ISelectWindowManager } from '@src/slide/application/service/select-window/core/select-window-manager.interface';
import { selectWindowDynamicConfig } from './service-dynamic-configs/select-window.config';
import { ocrPcServiceDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/ocr-service.config';
import { IAnimationEditorService } from '@src/slide/application/service/animation-editor-manager/core/interface';
import { animCategoryManagerConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/anim-category-manager.config';
import { animationEditorServiceDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/animation-editor-manager.config';
import { IDrawerStateManager } from '@src/slide/application/service/drawer-state-manager/core/drawer-state-manager.interface';
import { drawerStateManagerConfig } from './service-dynamic-configs/drawer-state-manager.config';
import ImportFileSelectManager from '@src/slide/application/service/import-file-select-modal-service';
import {
    importFileSelectManagerDynamicConfig,
} from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/import-file-select-manager.config';
import {
    IPropertyEditorManager,
} from '@src/slide/application/service/property-editor-manager/property-editor-manager.interface';
import {
    propertyEditorManagerConfig,
} from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/property-editor-manager.config';
import {
    pcShortcutPanelManagerDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/shortcut-panel-manager.config';
import { IShortcutPanelManager } from '@src/slide/application/service/shortcut-panel/shortcut-panel-manager.interface';
import { ISlideSizeService } from '@src/slide/application/service/slide-size-service/index.interface';
import {
    pcSlideSizeServiceDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/slide-size-service.config';
import OcrSideBarManager from '@src/slide/application/service/ocr-service/core/pc/ocr-sidebar-manager/ocr-sidebar-manager';
import {
    slideContentPreviewServiceDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/slide-content-preview.config';
import { ISlideContentPreviewService } from '@src/slide/application/service/slide-content-preview/core/slide-content-preview.interface';
import { IImageUploadService, IImageUploadServiceInjectable } from '@src/slide/application/service/image-upload-service/core/interface';
import { ImageUploadServiceInjectable } from '@src/slide/application/service/image-upload-service/inject/toc/image-upload-service-injectable';
import { imageUploadServiceDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/image-upload-service.config';
import { ITextSelectionUndoRedo } from '@src/slide/application/service/text-selection-undo-redo/interface';
import { TextSelectionUndoRedo } from '@src/slide/application/service/text-selection-undo-redo';
import {
    pcAIServiceDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/pc-ai-service.config';
import { IPcAiService } from '@src/slide/application/service/ai/core/pc/pc-ai-service.interface';
import {
    IAiControllerInjectable,
} from '@src/slide/application/service/ai-controller/inject/ai-controller-Injectable.interface';
import AiControllerInjectable from '@src/slide/application/service/ai-controller/inject/toc/ai-controller-injectable';
import PcAiController from '@src/slide/application/service/ai-controller/core/pc/pc-ai-controller';
import {
    getRatingServiceDynamicConfig,
} from '@src/slide/application/entry/toc/base/service-layer/service-dynamic-configs/rating-service.config';
import { ICopyPasteInjectable } from '@src/slide/application/service/copy-paste/inject/copy-paste-injectable.interface';
import CopyPasteInjectable from '@src/slide/application/service/copy-paste/inject/toc';
import { ITextSelectivePasteState } from '@src/slide/application/service/text-selective-paste-state/interface';
import TextSelectivePasteState from '@src/slide/application/service/text-selective-paste-state';
import { ITransitionService } from '@src/slide/application/service/transition-service/transition-service-interface';
import { IDrawerInputManager } from '@src/slide/application/service/drawer-input-manager/core/drawer-state-manager.interface';
import { drawerInputManagerConfig } from './service-dynamic-configs/drawer-input-manager.config';
import { IDriveSelectorPanelService } from '@src/slide/application/service/drive-selector-panel-service/core/interface';
import { pcDriveSelectorPanelServiceDynamicConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/drive-selector-panel-service.config';
import { getTransitionServiceConfig } from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/transition-service.config';
import { IAnimCategoryManager } from '@src/slide/application/service/anim-category-manager/interface';
import { IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { ISmartReplaceImageService } from '@src/slide/application/service/smart-replace-image/smart-replace-image-service.interface';
import { pcSmartReplaceImageConfig } from './service-dynamic-configs/smart-replace-image-service.config';
import { IMachineAuditor } from '@src/slide/application/service/slide-machine-audit/machine-auditor.interface';
import { pcSlideMachineAuditorConfig } from './service-dynamic-configs/slide-template-checker.config';
import { IAiReplaceSlidePCService } from '@src/slide/application/service/ai-replace-slide/ai-replace-slide-service.interface';
import { pcAIReplaceSlideConfig } from './service-dynamic-configs/ai-replace-slide-service.config';

export class PcEditorEditableServiceLayer
    extends EditorEditableServiceLayer implements IPcEditorEditableServiceLayer {
    declare public readonly viewableServiceLayer: IPcEditorViewableServiceLayer;
    declare public readonly aiService: IDynamicService<IPcAiService>;
    public readonly masterLayoutEditService: IMasterLayoutEditService;
    public readonly importOnlineFileManager: IDynamicService<IImportOnlineFileManager>;
    public readonly pagingSelectionManager: IPagingSelectionManager;
    public readonly paragraphManager: ParagraphManager;
    public readonly tempElementManager: TempElementManager;
    public readonly chartManager: ChartManager;
    public readonly selectedAnims: SelectedAnimManager;
    public readonly rightSideBarManager: RightSideBarManager;
    public readonly searchReplaceManager?: IDynamicService<ISearchReplaceManager>;
    public numberTestManager?: INumberTestManager;
    public guidesManager: GuidesManager;
    public readonly textRulerManager: ITextRulerManager;
    public readonly gridLineManager: GridLineManager;
    public readonly absorbManager: AbsorbManager;
    public readonly insertTableRowColManager: InsertTableRowColManager;
    public readonly ratingService: IDynamicService<ISlideRatingService>;
    public readonly copyPasteManager: IDynamicService<IPcCopyPaste>;
    public readonly importFileManager: IDynamicService<IImportFileManager>;
    public readonly importFilePipelineManager: IDynamicService<ImportFilePipelineManager>;
    public readonly importFileSelectManager: IDynamicService<ImportFileSelectManager>;
    public readonly bulletsAndNumberingDialogManager: IDynamicService<IBulletsAndNumberingDialogManager>;
    public readonly columnDialogDynamicManager: IDynamicService<IColumnDialogManager>;
    public readonly chartTrendlineManager: IDynamicService<IChartTrendlineManager>;
    public readonly insertTdocManager: IDynamicService<IInsertTdocManager>;
    public readonly historyManager: IHistoryManager;
    public readonly selectWindowManager: IDynamicService<ISelectWindowManager>;
    public readonly animCategoryManager: IDynamicService<IAnimCategoryManager>;
    public readonly animationEditorService: IDynamicService<IAnimationEditorService>;
    public readonly drawerInputManager: IDynamicService<IDrawerInputManager>;
    public readonly drawerStateManager: IDynamicService<IDrawerStateManager>;
    public readonly propertyEditorManager?: IDynamicService<IPropertyEditorManager>;
    public readonly shortcutPanelManager?: IDynamicService<IShortcutPanelManager>;
    public readonly ocrSideBarManager: OcrSideBarManager;
    public readonly slideContentPreviewService: IDynamicService<ISlideContentPreviewService>;
    public readonly imageUploadService: IDynamicService<IImageUploadService>;
    public readonly slideSizeService?: IDynamicService<ISlideSizeService>;
    public readonly textSelectionUndoRedo: ITextSelectionUndoRedo;
    public readonly textSelectivePasteState: ITextSelectivePasteState;
    public readonly driveSelectorPanelService: IDynamicService<IDriveSelectorPanelService>;
    public readonly transitionService: IDynamicService<ITransitionService>;
    public readonly smartReplaceImageService: IDynamicService<ISmartReplaceImageService>;
    public readonly slideMachineAuditor: IDynamicService<IMachineAuditor>;
    public readonly aiReplaceSlidePCService: IDynamicService<IAiReplaceSlidePCService>;

    public constructor(
        viewableServices: IPcEditorViewableServiceLayer,
        uiDataService: IUiDataService,
        infrastructure: IInfrastructureBase,
    ) {
        super(viewableServices, uiDataService);
        this.menuManager.setSectionManagerDelegate(viewableServices.sectionManager);
        this.menuManager.exportPreferenceService = viewableServices.exportPreferenceService;
        viewableServices.sectionManager.setUiDataServiceDelegate(uiDataService);
        viewableServices.sectionManager.setSelectionServiceDelegate(viewableServices.selectionService);
        this.masterLayoutEditService = new MasterLayoutEditService(
            uiDataService,
            viewableServices.selectionService,
            viewableServices.slideRenderStateManager,
            viewableServices.noteAreaManager,
        );
        viewableServices.selectionService.selectedWithCommit
            .setMasterLayoutEditServiceDelegate(this.masterLayoutEditService);
        viewableServices.selectionEventService.setMasterLayoutEditServiceDelegate(this.masterLayoutEditService);
        viewableServices.masterLayoutStyleService.setMasterLayoutEditServiceDelegate(this.masterLayoutEditService);
        if (browser.isPc) {
            this.menuManager.setMasterLayoutEditServiceDelegate(this.masterLayoutEditService);
        }

        this.selectedAnims = new SelectedAnimManager();
        viewableServices.selectionEventService.setSelectedAnimManagerDelegate(this.selectedAnims);
        this.undoRedoService.setSelectedAnimsDelegate(this.selectedAnims);
        this.rightSideBarManager = new RightSideBarManager();
        this.menuManager.setRightSideBarManagerDelegate(this.rightSideBarManager);
        this.menuManager.setRightSideBarServiceDelegate(viewableServices.rightSideBarService);
        this.lockService.setRightSideBarManagerDelegate(this.rightSideBarManager);
        viewableServices.commentManager.onDidInit(async (commentManager) => {
            commentManager.setRightSideBarManagerDelegate(this.rightSideBarManager);
            commentManager.setHistoryManagerDelegate(this.historyManager);
            commentManager.setMasterLayoutEditServiceDelegate(this.masterLayoutEditService);
        });
        this.pagingSelectionManager = new PagingSelectionManager();
        this.importFileManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(importFileManagerDynamicConfig);
        this.importFileManager.onDidInit((importFileManager) => {
            importFileManager.setPagingSelectionManager(this.pagingSelectionManager);
            importFileManager.setUiDataService(uiDataService);
            importFileManager.setSelectionService(viewableServices.selectionService);
            importFileManager.setImportFileInjectable(this.createImportFileInjectable());
        });
        viewableServices.addonManager.importFileManagerDelegate = this.importFileManager;
        this.importFilePipelineManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(importFilePipelineManagerDynamicConfig);
        this.importFilePipelineManager.onDidInit(async (importFilePipelineManager) => {
            importFilePipelineManager.setImportFileManagerDelegate(await this.importFileManager.promise());
            importFilePipelineManager.setPagingSelectionManagerDelegate(this.pagingSelectionManager);
            importFilePipelineManager.setImportFileSelectManagerDelegate(await this.importFileSelectManager.promise());
        });
        this.importFileSelectManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(importFileSelectManagerDynamicConfig);
        this.importOnlineFileManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(importOnlineFileManagerConfig);
        this.importOnlineFileManager.onDidInit((importOnlineFileManager) => {
            importOnlineFileManager.setPagingSelectionManagerDelegate(this.pagingSelectionManager);
        });
        this.menuManager.importOnlineFileManager = this.importOnlineFileManager;
        this.paragraphManager = new ParagraphManager(
            this.uiDataService,
            this.viewableServiceLayer.linkManager,
            this.viewableServiceLayer.fontManager,
        );
        this.paragraphManager.setSelectionServiceDelegate(viewableServices.selectionService);
        this.paragraphManager.setUserPriviledgeServiceDelegate(viewableServices.userPriviledgeService);
        this.paragraphManager.setTipsManagersDelegate(viewableServices.tipsManager);
        this.menuManager.setParagraphManager(this.paragraphManager);
        this.tempElementManager = new TempElementManager();
        this.tempElementManager.setSelectionServiceDelegate(viewableServices.selectionService);
        this.tempElementManager.setSelectedAnimsDelegate(this.selectedAnims);
        this.chartManager = new ChartManager();
        this.dragElementHandler.setMoveElementManagerDelegate(this.moveElementManager);
        this.dragElementHandler.setTempElementManagerDelegate(this.tempElementManager);
        this.absorbManager = new AbsorbManager();
        this.gridLineManager = new GridLineManager({
            absorbManager: this.absorbManager,
        });

        this.searchReplaceManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(searchReplaceManagerDynamicConfig);
        this.searchReplaceManager.onDidInit((searchReplaceManager) => {
            searchReplaceManager.setServiceDelegates({
                selectionService: viewableServices.selectionService,
                userPriviledgeService: viewableServices.userPriviledgeService,
                uiDataService,
                editorInstanceService: viewableServices.editorInstanceService,
                masterLayoutEditService: this.masterLayoutEditService,
                toolbarStateManager: viewableServices.toolbarStateManager,
            });
            searchReplaceManager.init();
        });

        onSlideAppReady(() => {
            const editable = SlideDataServices.PrivilegeManager()?.editable;
            if (editable) {
                this.guidesManager = new GuidesManager({
                    uiDataService,
                    masterLayoutEditService: this.masterLayoutEditService,
                    selectionService: viewableServices.selectionService,
                });
                this.menuManager.setGuidesManager(this.guidesManager);
                this.menuManager.setSnapLineService(this.snapLineService);
                this.dragElementHandler.setGuidesManagerDelegate(this.guidesManager);
                this.dragElementHandler.setSnapLineServiceDelegate(this.snapLineService);
                this.resizeElementHandler.setGuidesManagerDelegate(this.guidesManager);
                this.resizeElementHandler.setSnapLineServiceDelegate(this.snapLineService);
                this.gridLineManager.setGuidesManager(this.guidesManager);
                viewableServices.canvasService.setAsyncServiceDelegates({
                    guidesManager: this.guidesManager,
                });
            }
        });

        this.textRulerManager = new TextRulerManager({
            presentation: uiDataService.presentation,
            paragraphManager: this.paragraphManager,
            selectionService: viewableServices.selectionService,
            editorInstanceService: viewableServices.editorInstanceService,
            menuManager: this.menuManager,
        });
        this.menuManager.setTextRulerManager(this.textRulerManager);
        this.menuManager.setGridLineManager(this.gridLineManager);
        this.dragElementHandler.setAbsorbManagerDelegate(this.absorbManager);
        this.resizeElementHandler.setAbsorbManagerDelegate(this.absorbManager);
        this.insertTableRowColManager = new InsertTableRowColManager({
            selectionService: viewableServices.selectionService,
            menuManager: this.menuManager,
        });
        this.themeColorManager.setSlideContentEnumeratorService(this.slideContentEnumeratorService);
        this.menuManager.setInsertTableRowColManager(this.insertTableRowColManager);
        this.copyPasteManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcCopyPasteManagerDynamicConfig);
        initDynamicCopyPaste(
            this.copyPasteManager, uiDataService,
            this.menuManager, viewableServices,
            this.createCopyPasteInjectable(),
        );
        this.copyPasteManager?.onDidInit((copyPasteManager) => {
            copyPasteManager.setServiceDelegates({
                importNewFileManager: this.importNewFileManager,
                editAreaCanvasSizeManager: viewableServices.editAreaCanvasSizeManager,
                sectionManager: viewableServices.sectionManager,
                masterLayerEditService: this.masterLayoutEditService,
                importFileManager: this.importFileManager,
                importFilePipelineManager: this.importFilePipelineManager,
                toolbarStateManager: viewableServices.toolbarStateManager,
                importFileSelectManager: this.importFileSelectManager,
                shortCutKeyManager: this.viewableServiceLayer.shortCutKeyManager,
                imageUploadService: this.imageUploadService,
                contentRendererService: this.viewableServiceLayer.contentRendererService,
            });
            viewableServices.exportImageManager.setCopyPasteManager(copyPasteManager);
            viewableServices.printService.setCopyPasteManager(copyPasteManager);
            viewableServices.screenshotManager.setCopyPasteManager(copyPasteManager);
            viewableServices.screenshotManager.setExportImageManager(viewableServices.exportImageManager);
            viewableServices.screenshotManager.init();
        });
        this.bulletsAndNumberingDialogManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(bulletsAndNumberingDialogManagerDynamicConfig);
        this.bulletsAndNumberingDialogManager.onDidInit((bulletsAndNumberingDialogManager) => {
            bulletsAndNumberingDialogManager.setServiceDelegates({
                selectionService: viewableServices.selectionService,
                colorPickerManager: this.colorPickerManager,
                menuManager: this.menuManager,
                copyPasteImageService: this.copyPasteImageService,
            });
        });
        this.columnDialogDynamicManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(columnDialogDynamicConfig);
        this.columnDialogDynamicManager.onDidInit((columnDialogDynamicManager) => {
            columnDialogDynamicManager.setServiceDelegates({
                menuManager: this.menuManager,
            });
        });
        this.chartTrendlineManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(chartTrendlineManagerDynamicConfig);
        this.insertTdocManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(insertTdocManagerDynamicConfig);
        this.insertTdocManager.onDidInit((insertTdocManager) => {
            insertTdocManager.setSelectionServiceDelegate(viewableServices.selectionService);
            insertTdocManager.setLinkManagerDelegate(viewableServices.linkManager);
            insertTdocManager.setAttachmentManagerDelegate(viewableServices.attachmentManager);
        });
        this.menuManager.insertTdocManager = this.insertTdocManager;
        this.moveElementManager.setA11yManagerDelegate(viewableServices.accessibilityManager);
        this.quickToolDialogManager.onDidInit((quickToolDialogManager) => {
            quickToolDialogManager.setServiceDelegates({
                selectionService: viewableServices.selectionService,
                elementAutoLayoutService: this.elementAutoLayoutService,
                numberTestManager: this.numberTestManager,
                masterLayoutEditService: this.masterLayoutEditService,
                toolbarStateManager: viewableServices.toolbarStateManager,
                tipsManager: viewableServices.tipsManager,
                userPrivilegeService: viewableServices.userPriviledgeService,
            });
        });
        this.historyManager = new HistoryManager(
            uiDataService,
            viewableServices.selectionService,
            viewableServices.exportManager,
            viewableServices.userPriviledgeService,
            this.lockService,
            viewableServices.accusationService,
            viewableServices.rightSideBarService,
            this.menuManager,
            this.createHistoryManagerInjectable(),
            this.selectedAnims,
        );
        viewableServices.cursorManager.onDidInit((cursorManager) => {
            cursorManager.historyManager = this.historyManager;
        });
        viewableServices.urlParamManager.onDidInit((urlParamManager) => {
            urlParamManager.setServiceDelegates({ historyManager: this.historyManager });
        });
        this.lockService.setHistoryManagerDelegate(this.historyManager);
        viewableServices.selectionEventService.setHistoryManagerDelegate(this.historyManager);
        viewableServices.tipsManager.setHistoryManagerDelegate(this.historyManager);
        this.menuManager.historyManager = this.historyManager;
        this.copyPasteManager.onDidInit((copyPasteManager) => {
            copyPasteManager.setHistoryManagerDelegate(this.historyManager);
        });
        this.drawerInputManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(drawerInputManagerConfig);
        this.drawerStateManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(drawerStateManagerConfig);
        this.drawerStateManager.onDidInit((drawerStateManager) => {
            drawerStateManager.setServiceDelegates({
                rightSideBarManager: this.rightSideBarManager,
                rightSideBarService: viewableServices.rightSideBarService,
                userPrivilegeService: this.viewableServiceLayer.userPriviledgeService,
                commentManager: viewableServices.commentManager,
            });
        });
        this.selectWindowManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(selectWindowDynamicConfig);
        this.selectWindowManager.onDidInit((selectWindowManager) => {
            selectWindowManager.setServiceDelegates({
                rightSideBarManager: this.rightSideBarManager,
                selectionService: viewableServices.selectionService,
                rightSideBarService: viewableServices.rightSideBarService,
            });
        });
        this.shortcutPanelManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcShortcutPanelManagerDynamicConfig);
        this.shortcutPanelManager.onDidInit((shortcutPanelManager) => {
            shortcutPanelManager.setServiceDelegates({
                rightSideBarService: viewableServices.rightSideBarService,
            });
            shortcutPanelManager.registerRightSideBar();
        });
        viewableServices.rightMenuManager.onDidInit((rightMenuManager) => {
            rightMenuManager.setServicesDelegate({
                menuManager: this.menuManager,
            });
        });
        viewableServices.inactivityGuideService.setServicesDelegate({
            menuManager: this.menuManager,
            produceBackupManager: viewableServices.produceBackupManager,
        });
        viewableServices.shortCutKeyManager.onDidInit((shortCutKeyManager) => {
            shortCutKeyManager.setServicesDelegates({
                animBrushManager: this.dynamicAnimBrushManager,
                menuManager: this.menuManager,
                masterLayoutEditService: this.masterLayoutEditService,
                searchReplaceManager: this.searchReplaceManager,
                selectedAnims: this.selectedAnims,
                copyPasteManager: this.copyPasteManager,
                formatBrushManager: this.formatBrushManager,
                moveElementManager: this.moveElementManager,
                historyManager: this.historyManager,
                drawerStateManager: this.drawerStateManager,
                shortcutPanelManager: this.shortcutPanelManager,
                printService: viewableServices.printService,
            });
        });
        this.ocrSideBarManager = new OcrSideBarManager();
        this.ocrSideBarManager.setServiceDelegates({
            rightSideBarService: viewableServices.rightSideBarService,
        });
        this.ocrSideBarManager.registerRightSideBar();
        this.ocrService = DynamicServiceLoader.getInstance()
            .registerDynamicService(ocrPcServiceDynamicConfig);
        this.ocrService.onDidInit((ocrService) => {
            ocrService.setServiceDelegates({
                ocrSideBarManager: this.ocrSideBarManager,
            });
        });
        this.aiService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcAIServiceDynamicConfig);
        this.aiService.onDidInit((aiService: IPcAiService) => {
            aiService.setServiceDelegates({
                playManager: this.viewableServiceLayer.playManager,
                rightSideBarManager: this.rightSideBarManager,
                masterLayoutEditService: this.masterLayoutEditService,
                historyManager: this.historyManager,
                selectionService: viewableServices.selectionService,
                themeColorManager: this.themeColorManager,
                uiDataService,
                slideSizeService: this.slideSizeService,
                aiReplaceImageService: this.smartReplaceImageService,
            });
        });
        this.aiController = new PcAiController(this.createAiControllerInjectable());
        this.aiController.setServiceDelegates({
            aiService: this.aiService,
            aiAssistantService: this.aiAssistantService,
        });
        this.slideContentPreviewService = DynamicServiceLoader.getInstance()
            .registerDynamicService(slideContentPreviewServiceDynamicConfig);

        this.ratingService = DynamicServiceLoader.getInstance()
            .registerDynamicService(getRatingServiceDynamicConfig(
                uiDataService,
                viewableServices.selectionService,
                this.slideContentEnumeratorService,
                this.contentLayoutAnalyzer,
                this.quickToolDialogManager,
                this.viewableServiceLayer.rightSideBarService,
                this.slideContentPreviewService,
                this.drawerStateManager,
                this.rightSideBarManager,
            ));

        // canvas组件ViewService绑定edit相关Service
        viewableServices.canvasService.setEditServiceDelegates({
            masterLayoutEditService: this.masterLayoutEditService,
            selectedAnims: this.selectedAnims,
            chartManager: this.chartManager,
            textRulerManager: this.textRulerManager,
            themeColorManager: this.themeColorManager,
            gridLineManager: this.gridLineManager,
            drawerStateManager: this.drawerStateManager,
        });
        // pc slideList组件ViewService绑定edit相关Service
        viewableServices.slideListService.setEditServiceDelegates({
            masterLayoutEditService: this.masterLayoutEditService,
            historyManager: this.historyManager,
            rightSideBarManager: this.rightSideBarManager,
            selectedAnims: this.selectedAnims,
            copyPasteImageService: this.copyPasteImageService,
            menuManager: this.menuManager,
        });
        this.animCategoryManager = DynamicServiceLoader.getInstance().registerDynamicService(animCategoryManagerConfig);
        this.animCategoryManager?.onDidInit((animCategoryManager) => {
            animCategoryManager.setServiceDelegates({
                selectionService: viewableServices.selectionService,
                selectedAnimManager: this.selectedAnims,
            });

            this.animBrushManager?.updateServiceDelegates({ animCategoryManager });
        });
        this.animationEditorService = DynamicServiceLoader.getInstance()
            .registerDynamicService(animationEditorServiceDynamicConfig);
        this.animationEditorService.onDidInit((animationEditorManager) => {
            animationEditorManager.setServiceDelegates({
                menuManager: this.menuManager,
                editorAnimPreviewManager: viewableServices.getEditorAnimPreviewManager,
                selectedAnims: this.selectedAnims,
                animManager: viewableServices.animManager,
                selectionService: viewableServices.selectionService,
                animCategoryManager: this.animCategoryManager,
                rightSideBarManager: this.rightSideBarManager,
                rightSideBarService: this.viewableServiceLayer.rightSideBarService,
            });
        });
        this.propertyEditorManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(propertyEditorManagerConfig);

        this.propertyEditorManager?.onDidInit((propertyEditorManager) => {
            propertyEditorManager.setDelegate({
                menuManager: this.menuManager,
                rightSideBarManager: this.rightSideBarManager,
                selectionService: this.viewableServiceLayer.selectionService,
                masterLayoutEditService: this.masterLayoutEditService,
                userPriviledgeService: this.viewableServiceLayer.userPriviledgeService,
                copyPasteImageService: this.copyPasteImageService,
                rightSideBarService: this.viewableServiceLayer.rightSideBarService,
            });
        });

        this.imageUploadService = DynamicServiceLoader.getInstance()
            .registerDynamicService(imageUploadServiceDynamicConfig);
        this.imageUploadService.onDidInit((imageUploadService) => {
            imageUploadService.setServiceDelegates({
                selectionService: viewableServices.selectionService,
                copyPasteImageService: this.copyPasteImageService,
                toolbarStateManager: viewableServices.toolbarStateManager,
                menuManager: this.menuManager,
                uiDataService,
                quickToolDialogManager: this.quickToolDialogManager,
            });
            imageUploadService.setImageUploadServiceInjectable(this.createImageUploadServiceInjectable());
        });

        this.slideSizeService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcSlideSizeServiceDynamicConfig);
        this.slideSizeService.onDidInit((module) => {
            module.setDelegate({
                uiDataService,
            });
        });

        this.driveSelectorPanelService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcDriveSelectorPanelServiceDynamicConfig);
        this.driveSelectorPanelService.onDidInit((pcDriveSelectorPanelService) => {
            pcDriveSelectorPanelService.setServiceDelegates({
                attachmentManager: viewableServices.attachmentManager,
            });
        });

        this.textSelectionUndoRedo = new TextSelectionUndoRedo();
        this.textSelectionUndoRedo.setEditorInstanceServiceDelegate(viewableServices.editorInstanceService);
        viewableServices.selectionService.selectedWithCommit
            .setTextSelectionUndoRedoDelegate(this.textSelectionUndoRedo);

        this.textSelectivePasteState = new TextSelectivePasteState();

        viewableServices.extensionService.setServiceDelegates({
            selectionService: viewableServices.selectionService,
            rightSideBarService: viewableServices.rightSideBarService,
            userPriviledgeService: viewableServices.userPriviledgeService,
            historyManager: this.historyManager,
            masterLayoutEditService: this.masterLayoutEditService,
            lifeCycleService: viewableServices.lifeCycleService,
        });

        this.transitionService = DynamicServiceLoader.getInstance()
            .registerDynamicService(getTransitionServiceConfig(uiDataService, viewableServices, this, infrastructure));

        this.smartReplaceImageService = DynamicServiceLoader
            .getInstance().registerDynamicService(pcSmartReplaceImageConfig);
        this.smartReplaceImageService.onDidInit((module) => {
            module.setDelegateService({
                uiDataService: this.uiDataService,
                selectionService: viewableServices.selectionService,
                rightSideBarManager: this.rightSideBarManager,
                editAreaCanvasSizeManager: viewableServices.editAreaCanvasSizeManager,
                aiService: this.aiService,
                drawerStateManager: this.drawerStateManager,
            });
        });

        this.slideMachineAuditor = DynamicServiceLoader
            .getInstance().registerDynamicService(pcSlideMachineAuditorConfig);
        this.slideMachineAuditor.onDidInit((module) => {
            module.setDelegateService({
                enumerator: this.slideContentEnumeratorService,
                uiDataService: this.uiDataService,
                templateContentAnalyzer: this.templateContentAnalyzerService,
                rightSideBarManager: this.rightSideBarManager,
                drawerStateManager: this.drawerStateManager,
                selectionService: this.viewableServiceLayer.selectionService,
            });
        });

        this.aiReplaceSlidePCService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcAIReplaceSlideConfig(
                this.uiDataService,
                this.viewableServiceLayer.selectionService,
                this.aiAssistantService,
            ));
    }

    protected createImportFileInjectable(): IImportFileInjectable {
        return new ImportFileInjectable();
    }

    protected createHistoryManagerInjectable(): IHistoryManagerInjectable {
        return new HistoryManagerInjectable();
    }

    protected createImageUploadServiceInjectable(): IImageUploadServiceInjectable {
        return new ImageUploadServiceInjectable();
    }

    protected createAiControllerInjectable(): IAiControllerInjectable {
        return new AiControllerInjectable();
    }

    protected createCopyPasteInjectable(): ICopyPasteInjectable {
        return new CopyPasteInjectable();
    }
}
